import { UserActionSheet } from "@/components/ActionSheet";
import {
  Dialog,
  EditIc,
  EllipsisHorizontalIc,
  ReportContentIc,
  TranslateIc,
} from "@/components/Elements";
import useToggle from "@/hooks/useToggle";
import { ReportContent, TranslateText } from "@/features/misc/components";
import { PotsActionType } from "../../user/types";

const PostAction = ({
  type,
  translateText,
  handleReport,
  handleTranslate,
  showReportContent,
  showEdit,
  handleEdit,
}: {
  type: PotsActionType;
  translateText: string;
  handleReport: (reasonId: string) => void;
  handleTranslate: (text: string) => void;
  showReportContent?: boolean;
  showEdit?: boolean;
  handleEdit?: () => void;
}) => {
  const { show: showTranslateModal, toggle: toggleTranslateModal } =
    useToggle();
  const { show: showReportContentModal, toggle: toggleReportContentModal } =
    useToggle();

  const onTranslated = (text: string) => {
    toggleTranslateModal();
    handleTranslate(text);
  };

  const onReport = (reasonId: string) => {
    toggleReportContentModal();
    handleReport(reasonId);
  };

  return (
    <>
      <UserActionSheet
        options={[
          ...(showReportContent
            ? [
                {
                  text: "Report Content",
                  icon: <ReportContentIc className="h-10 w-10" />,
                  value: "Report",
                  onClick: toggleReportContentModal,
                },
              ]
            : []),
          {
            text: "Translate",
            icon: <TranslateIc className="h-5 w-5" />,
            value: "Translate",
            onClick: toggleTranslateModal,
          },
          ...(showEdit && handleEdit
            ? [
                {
                  text: "Edit",
                  icon: <EditIc className="h-5 w-5" />,
                  value: "Edit",
                  onClick: handleEdit,
                },
              ]
            : []),
        ]}
      >
        <EllipsisHorizontalIc className="h-10 w-10" />
      </UserActionSheet>
      {showTranslateModal && (
        <Dialog
          isOpen={showTranslateModal}
          onClose={toggleTranslateModal}
          title="Translate"
        >
          <TranslateText
            text={translateText}
            handleClose={toggleTranslateModal}
            onTranslated={onTranslated}
          />
        </Dialog>
      )}
      {showReportContentModal && (
        <Dialog
          isOpen={showReportContentModal}
          onClose={toggleReportContentModal}
          title="Report Content"
        >
          <ReportContent type={type} handleReport={onReport} />
        </Dialog>
      )}
    </>
  );
};

export default PostAction;
